function hasScrollbar() {
    return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight);
}
/**
 * @description: 判断是否是移动端
 * @return {*}
 */
export const getDeviceType = () => {
    var ua = navigator.userAgent,
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isChrome = /(?:Chrome|CriOS)/.test(ua),
    isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox &&
        /(?:Tablet)/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isSymbian;
    return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isMobile: !isTablet && !isPc,
        isPc: isPc
    };
}
/**
 * @description: 屏幕缩放事件
 * @return {*}
 */
export const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
/**
 * @description: 获取屏幕宽度
 * @return {*}
 */
export const getClientWidth = (scrollWidth = 17) => {
    let clientWidth = document.documentElement.clientWidth; // 不包括滚动条宽度
    if(hasScrollbar()) clientWidth+= scrollWidth;
    return clientWidth;
}

export function windowResizeEvent(callback) {
    window.onresize = function() {
        var target = this;
        if (target.resizeFlag) {
            clearTimeout(target.resizeFlag);
        }
        
        target.resizeFlag = setTimeout(function() {
            callback();
            target.resizeFlag = null;
        }, 100);
    }
}


// WEBPACK FOOTER //
// ./src/utils/device.js